import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import type { PartNode } from '@partful/shared-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NamedLink } from 'src/services/partNavigation';
import { BreadcrumbsEllipsis } from './BreadcrumbsEllipsis';
import { StyledMUILink, StyledNavigateNextIcon, TextWithShadow } from './styles';

interface IProps {
  current?: Pick<PartNode, 'name'> | { name: string };
  parents: NamedLink[];
  maxSteps?: number;
  isKit?: boolean;
}

export function ContrastBreadcrumbs({ current, parents, maxSteps = 100, isKit }: Readonly<IProps>) {
  const [hideMiddleSteps, setHideMiddleSteps] = useState(false);
  const { t } = useTranslation('partsCatalogue');

  useEffect(() => {
    setHideMiddleSteps(parents.length >= maxSteps);
  }, [parents.length, maxSteps]);

  /* istanbul ignore next */
  if (!current) {
    return null;
  }

  return (
    <MUIBreadcrumbs separator={<StyledNavigateNextIcon />} maxItems={Number.MAX_VALUE} aria-label="breadcrumbs">
      {parents.map((parent, index) => {
        /* istanbul ignore next */
        const shouldHide = hideMiddleSteps && index;
        /* istanbul ignore next */

        if (shouldHide) {
          return <BreadcrumbsEllipsis key="ellipsis" onClick={() => setHideMiddleSteps(false)} />;
        }
        return (
          <StyledMUILink key={parent.url} to={parent.url} data-testid="bom-parent-node">
            {parent.name}
          </StyledMUILink>
        );
      })}
      {isKit && (
        <StyledMUILink
          key={parents[0].url}
          to={{
            pathname: parents[0].url,
            state: { activeSidebarTab: 'kits' },
          }}
          data-testid="bom-parent-node"
        >
          {t('kitSection.kit_other')}
        </StyledMUILink>
      )}
      <TextWithShadow data-testid="bom-current-node" aria-current="true">
        {current.name}
      </TextWithShadow>
    </MUIBreadcrumbs>
  );
}
